import {useI18n} from '@/i18n'
import {JobSource} from '@/types/background-jobs'

export function useJobSourceLabel() {
    const i18n = useI18n()
    return (source: JobSource): string => {
        switch (source) {
            case JobSource.STATIC:
                return i18n.backgroundJobs.sourceStatic
            case JobSource.DYNAMIC:
                return i18n.backgroundJobs.sourceDynamic
            case JobSource.TESTDATA:
                return i18n.backgroundJobs.sourceTestdata
        }
    }
}
